var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.downloads),function(download){return _c('a',{key:download.Original,staticClass:"download",attrs:{"href":download.Original,"target":"_blank"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$root.md(download.Captions[0]))}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.getExtension(download.Original))}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-747a3713","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Filedownload.vue
// module id = null
// module chunks = 